export function createSvgIconSprite() {
  const requireContext = require.context('./', true, /\.svg$/);

  requireContext.keys().forEach(requireContext);
}
